import 'videojs-contrib-ads';
import 'videojs-ima';
import { device } from 'vimmi-web-utils/cjs/device';
import Config from '../services/config';
import vimmiPI from './vimmiPI';
import { normalizeLang } from 'vimmi-web-utils/cjs/normalizeLang';
import vjsSrv from '../services/vjsSrv';
import { EventEmitter } from 'vimmi-web-utils/cjs/eventEmitter';
import Tools from '../services/tools';
import autoplayState from '../services/autoplayState';
import Analytics from './analytics';
import { AdsCustomUi } from './ads-custom-ui';
import eventsSrv from '../services/events';
import { PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';
import $logger from 'src/js/logger';

export class Ads extends EventEmitter {
  constructor() {
    super();

    this.autoplayBrowserAllow = false;
    this.mutedAutoplayBrowserAllow = false;
    this.hasPreRoll = false;
    this.hasMidRoll = false;
    this.hasPostRoll = false;
    this.isImaLoaded = null;
    this.withAutoplay = false;
    this.isLive = false;
    this.isAdInit = false;
    this.isAdDisplayContainerInit = false;
    this.withAds = false;
    this._playing = false;
    this.isBuggedIos = (device.isIphone() || device.isIpad()) && (device.isSafari() || device.isChrome());

    this.adsUi = new AdsCustomUi(this);

    // this.firstPlayAds = true;
    this.startEvent = device.isAnyMobile() ? 'tap' : 'click';
  }

  async _loadImaSdk() {
    if (this.isImaLoaded !== null) {
      return this.isImaLoaded;
    }

    return new Promise((resolve, reject) => {
      let script = Tools.addScript('ga-ima-sdk', '//imasdk.googleapis.com/js/sdkloader/ima3.js');
      script.onload = script.onerror = (event) => {
        this.isImaLoaded = event.type === 'load';
        resolve(this.isImaLoaded);
      };
    });
  }

  async _initIma({ adTag, adVast }) {
    vjsSrv.vjsPlayer.on('adslog', this.onAdLog.bind(this));
    vjsSrv.vjsPlayer.on('adserror', this.onAdError.bind(this));
    vjsSrv.vjsPlayer.on('adtimeout', this.onAdTimeout.bind(this));
    vjsSrv.vjsPlayer.one('touchend', this.initializeAdDisplayContainer.bind(this));
    vjsSrv.vjsPlayer.on('timeupdate', () => {
      // if (vjsSrv.vjsPlayer.currentTime() > 0 && vjsSrv.vjsPlayer.currentTime() > vjsSrv.vjsPlayer.duration() - 2 && this.adsManager) {
      //   this.adsManager.stop();
      // }
      if (this.playing() && this.ad.isLinear()) {
        vjsSrv.vjsPlayer.pause();
      }
    });
    vjsSrv.vjsPlayer.on('durationchange', () => {
      this.checkVASTRolls(vjsSrv.vjsPlayer.ima.controller.getSettings().adsResponse, false);
      if (!this.hasPreRoll && !this.isLive && !Config.get('eventsState.sourceChanging')) {
        eventsSrv.emit(PLAYER_EVENTS.ADS_AFTER_PREROLL);
      }
    });
    vjsSrv.vjsPlayer.on('ended', () => {
      if (this.closeBannerTimeoutId) {
        // this.adsManager.skip();
        clearTimeout(this.closeBannerTimeoutId);
        this.closeBannerTimeoutId = null;
      }
    });
    vjsSrv.vjsPlayer.on('ads-request', ({ AdsRequest }) => {
      if (AdsRequest.adsResponse) {
        this.checkVASTRolls(AdsRequest.adsResponse);
      }
    });
    this.autoplayBrowserAllow = await autoplayState.checkAutoPlayState();
    this.mutedAutoplayBrowserAllow = await autoplayState.checkMutedAutoPlayState();
    // let isAdblock = this.checkAdblock();
    this.autoPlayAdBreaks = false;
    this.adsUi.preInit();
    this.imaOptions = {
      id: Config.get('playerId'),
      debug: Config.get('debug'),
      // adLabel: vjsSrv.vjsPlayer.localize('Advertisement'),
      // adLabelNofN: vjsSrv.vjsPlayer.localize('of'),
      requestMode: 'onPlay',
      // requestMode: 'onLoad',
      locale: normalizeLang(Config.get('params.lang'), 'iso-2'),
      autoPlayAdBreaks: this.autoPlayAdBreaks,
      adsRenderingSettings: {
        enablePreloading: false,
        // restoreCustomPlaybackStateOnAdBreakComplete: false,
        // autoAlign: false,
        // bitrate: -1
        disableClickThrough: device.isAnyMobile() || device.isTablet(), // use custom logic because mobile ignore first click after unmute)
        // disableUi: true,
        // loadVideoTimeout: 8000
        // mimeTypes: null
        // playAdsAfterTime: -1
        // uiElements: null,
        useLearnMoreButton: false,
        // useStyledLinearAds: true,
        useStyledNonLinearAds: true
        // useVideoAdUi: true
      },
      contribAdsSettings: { // http://videojs.github.io/videojs-contrib-ads/integrator/options.html
        disableNextSnapshotRestore: true,
        debug: Config.get('debug'),
        liveCuePoints: false,
        // contentIsLive: vimmiPI.getActiveAsset().get('isLive'),
        timeout: this.adexTimeout(),
        prerollTimeout: this.adexTimeout(),
        // showCountdown: false,
        postrollTimeout: this.adexTimeout()
      },
      preventLateAdStart: true,
      showCountdown: false,
      disableCustomPlaybackForIOS10Plus: true,//device.isAppleDevice() && !isAdblock,
      adsManagerLoadedCallback: this.adsManagerLoadedCallback.bind(this),
      trackByWatchTime: this.isLive,
      clickTrackingElement: device.isAnyMobile() ? this.adsUi.uiCustomClickBtn : undefined, // this.adsUi.uiCustomClickBtn : undefined,
      syncVolume: true
    };
    if (adTag) {
      this.imaOptions.adTagUrl = adTag;
    } else if (adVast) {
      this.imaOptions.adsResponse = adVast;
    }
    vjsSrv.vjsPlayer.ima(this.imaOptions);
    $logger.p('ads/init').log(vjsSrv.vjsPlayer.ads.settings);
    this.isAdInit = true;
    Analytics.send('ad_request');
  }

  initializeAdDisplayContainer() {
    if (!this.isAdInit) return;
    if (this.isBuggedIos) {
      if (!this.playing() && !this.isAdDisplayContainerInit) {
        vjsSrv.vjsPlayer.ima.controller.sdkImpl.adDisplayContainer.initialize();
        vjsSrv.vjsPlayer.ima.controller.sdkImpl.adDisplayContainerInitialized = true;
        $logger.p('ads/initializeAdDisplayContainer').log('force on ios');
      }
    } else if (!this.isAdDisplayContainerInit) {
      vjsSrv.vjsPlayer.ima.initializeAdDisplayContainer();
      $logger.p('ads/initializeAdDisplayContainer').log('initializeAdDisplayContainer');
    }
    this.isAdDisplayContainerInit = true;
    return true;
  }

  async _changeImaAd({ adTag, adVast }) {
    return new Promise((resolve, reject) => {
      if (adTag) {
        vjsSrv.vjsPlayer.ima.changeAdTag(adTag);
      } else {
        vjsSrv.vjsPlayer.ima.controller.reset();
        vjsSrv.vjsPlayer.ima.controller.setSetting('adsResponse', adVast);
      }
      vjsSrv.vjsPlayer.ima.controller.setSetting('trackByWatchTime', this.isLive);
      if (Config.get('eventsState.isCallPlay')) {
        if (this.playWatcher) {
          vjsSrv.vjsPlayer.off('loadstart', this.playWatcher);
          this.playWatcher = null;
        }
        this.playWatcher = () => {
          vjsSrv.vjsPlayer.ima.requestAds();
          this.playWatcher = null;
        };
        vjsSrv.vjsPlayer.one('loadstart', this.playWatcher);
      }
      Analytics.send('ad_request');
      resolve(true);
    });
  }

  updateImaAd(adVast) {
    if (adVast !== vjsSrv.vjsPlayer.ima.controller.getSettings().adsResponse) {
      vjsSrv.vjsPlayer.ima.controller.reset();
      vjsSrv.vjsPlayer.ima.controller.setSetting('adsResponse', adVast);
      vjsSrv.vjsPlayer.ima.requestAds();
      Analytics.send('ad_request');
    }
  }

  adexTimeout() {
    let adsTimeout = 6000;
    if (vimmiPI.getActiveAsset() && vimmiPI.getActiveAsset().get('adex.timeout_rpriority') === 'adex' && vimmiPI.getActiveAsset().get('adex.timeout')) {
      adsTimeout = vimmiPI.getActiveAsset().get('adex.timeout') * 1000;
    }
    return adsTimeout;
  }

  async handleAds({ adTag, adVast }, adVolume = null, withAutoplay, isLive) {
    if (!adTag && !adVast) {
      return false;
    }
    if (this.closeBannerTimeoutId) {
      clearTimeout(this.closeBannerTimeoutId);
      this.closeBannerTimeoutId = null;
    }
    // this.firstPlayAds = false;

    this.hasPreRoll = false;
    this.hasMidRoll = false;
    this.hasPostRoll = false;

    this.withAutoplay = withAutoplay;
    await this._loadImaSdk();
    if (!this.isImaLoaded) {
      $logger.p('ads/handleAds').error('ima sdk doesn\'t loaded');
      return null;
    }
    this.isLive = isLive;
    this.withAds = true;
    if (this.isAdInit) {
      vjsSrv.vjsPlayer.ads.settings.timeout = this.adexTimeout();
      vjsSrv.vjsPlayer.ads.settings.prerollTimeout = this.adexTimeout();
      vjsSrv.vjsPlayer.ads.settings.postrollTimeout = this.adexTimeout();
      return this._changeImaAd({ adTag, adVast });
    } else {
      return await this._initIma({ adTag, adVast });
    }
  }

  get adsManager() {
    return vjsSrv.vjsPlayer.ima?.getAdsManager ? vjsSrv.vjsPlayer.ima.getAdsManager() : null;
  }

  get ad() {
    return this.currentAd || this.adsManager.getCurrentAd();
  }

  playing() {
    return this._playing;
  }

  pauseAds() {
    vjsSrv.vjsPlayer.ima.pauseAd();
  }

  checkVASTRolls(adVast, trigger = true) {
    const str = adVast.toLowerCase();

    this.hasPreRoll = str.includes('preroll');
    this.hasMidRoll = str.includes('midroll');
    this.hasPostRoll = str.includes('postroll');
    if (trigger) {
      if (!this.hasPreRoll) {
        vjsSrv.vjsPlayer.trigger('nopreroll');
      } else {
        vjsSrv.vjsPlayer.ads.nopreroll_ = false;
      }
      if (!this.hasPostRoll) {
        vjsSrv.vjsPlayer.trigger('nopostroll');
      } else {
        vjsSrv.vjsPlayer.ads.nopostroll_ = false;
      }
    }
  }

  adsManagerLoadedCallback() {
    let adsManager = vjsSrv.vjsPlayer.ima.getAdsManager();
    this.adsUi.init();
    $logger.p('ads/IMA/adsManager').log({
      adsManager: adsManager
    });

    let events = [
      google.ima.AdEvent.Type.AD_METADATA,
      google.ima.AdEvent.Type.AD_BUFFERING,
      google.ima.AdEvent.Type.AD_CAN_PLAY,
      google.ima.AdEvent.Type.AD_BREAK_READY,
      google.ima.AdEvent.Type.AD_PROGRESS,
      google.ima.AdEvent.Type.CLICK,
      google.ima.AdEvent.Type.LOADED,
      google.ima.AdEvent.Type.STARTED,
      google.ima.AdEvent.Type.FIRST_QUARTILE,
      google.ima.AdEvent.Type.MIDPOINT,
      google.ima.AdEvent.Type.PAUSED,
      google.ima.AdEvent.Type.RESUMED,
      google.ima.AdEvent.Type.THIRD_QUARTILE,
      google.ima.AdEvent.Type.COMPLETE,
      google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
      google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
      google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
      google.ima.AdEvent.Type.DURATION_CHANGE,
      google.ima.AdEvent.Type.INTERACTION,
      google.ima.AdEvent.Type.IMPRESSION,
      google.ima.AdEvent.Type.LINEAR_CHANGED,
      google.ima.AdEvent.Type.SKIPPED,
      google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED,
      google.ima.AdEvent.Type.USER_CLOSE,
      google.ima.AdEvent.Type.VIDEO_CLICKED,
      google.ima.AdEvent.Type.VOLUME_CHANGED,
      google.ima.AdEvent.Type.VOLUME_MUTED,
      google.ima.AdEvent.Type.VIDEO_ICON_CLICKED
    ];
    if (!this.autoPlayAdBreaks) {
      vjsSrv.vjsPlayer.ima.setAdBreakReadyListener((adEvent) => {
        $logger.p('ads/IMA/event').log(adEvent.type, adEvent);
        vjsSrv.vjsPlayer.ima.playAdBreak();
      });
    }
    for (let index = 0; index < events.length; index++) {
      adsManager.addEventListener(
        events[index],
        this.onAdEvent.bind(this));
    }

    adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this));
  }

  onAdTimeout(adEvent) {
    $logger.p('ads/IMA/timeout').log(adEvent?.type, adEvent);
  }

  onAdError(adEvent) {
    if (adEvent?.data?.AdError && adEvent?.data?.AdError.getErrorCode() === 501) {
      if (vjsSrv.vjsPlayer.duration() - 20 > vjsSrv.vjsPlayer.currentTime()) {
        setTimeout(() => {
          this.adsManager.resize();
          vjsSrv.vjsPlayer.ima.requestAds();
        }, 3000);
      }
    }
    $logger.p('ads/IMA/error').log(adEvent?.type, adEvent);
  }

  onAdLog(adEvent) {
    $logger.p('ads/IMA/log').log(adEvent?.type, adEvent);
  }

  onAdEvent(adEvent) {
    const ad = adEvent.getAd();
    $logger.p('ads/IMA/event').log(adEvent?.type, adEvent, {
      ad,
      currentAd: this.currentAd,
      isLinear: ad ? ad.isLinear() : this.currentAd ? this.currentAd.isLinear() : false
    });
    Analytics.send('ad_vast_event', {
      itype: adEvent.type
    });

    if (adEvent.type === google.ima.AdEvent.Type.LOADED) {
      // if (this.closeBannerTimeoutId) {
      //   clearTimeout(this.closeBannerTimeoutId);
      //   this.closeBannerTimeoutId = null;
      // }
      // if (ad.isLinear() && this.closeBannerTimeoutId) { // cancel banner close timeout
      //   clearTimeout(this.closeBannerTimeoutId);
      //   this.closeBannerTimeoutId = null;
      // }
      // if (this.currentAd && !this.currentAd.isLinear() && this.playing()) {
      //   this.currentAd = null;
      // this.adsManager.discardAdBreak();
      // vjsSrv.vjsPlayer.ima.controller.sdkImpl.onContentResumeRequested()
      //
      // }
    }
    if (adEvent.type === google.ima.AdEvent.Type.AD_BREAK_READY) {
      if (ad) {
        if (ad.isLinear()) {
          vjsSrv.vjsPlayer.addClass('custom-waiting-video');
        }

        /*else if (!this.autoPlayAdBreaks) {// to show banner (non linear)
          vjsSrv.vjsPlayer.ima.playAdBreak();
        }*/
      }
    }
    if (adEvent.type === google.ima.AdEvent.Type.ALL_ADS_COMPLETED) {
      this.emit('finished');
    }
    if (adEvent.type === google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED) {
      if (vimmiPI.getActiveAsset().get('state.ready') && !vjsSrv.vjsPlayer.ads._shouldBlockPlay) {
        vjsSrv.vjsPlayer.removeClass('custom-waiting-video');
      }
      if (vjsSrv.vjsPlayer.paused()) {
        vjsSrv.vjsPlayer.play();
      }
      this._playing = false;
      let getAdPodInfo = ad.getAdPodInfo();
      if (!this.isLive && this.hasPreRoll && getAdPodInfo && getAdPodInfo.getPodIndex) {
        if (getAdPodInfo.getPodIndex() === 0) {
          eventsSrv.emit(PLAYER_EVENTS.ADS_AFTER_PREROLL);
        }
      }
      this.currentAd = null;

    }
    if (adEvent.type === google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED) {
      if (ad && ad.isLinear()) {
        vjsSrv.vjsPlayer.addClass('custom-waiting-video');
      }
      if (!vjsSrv.vjsPlayer.paused()) {
        vjsSrv.vjsPlayer.pause();
      }
    }
    if (adEvent.type === google.ima.AdEvent.Type.CLICK) {
      if ((device.isAnyMobile() || device.isTablet()) && this.ad && !this.ad.isLinear() && this.adsUi?.clickThroughUrl) {
        let a = document.createElement('a');
        a.href = this.adsUi.clickThroughUrl;
        a.target = '_blank';
        a.click();
      }
      setTimeout(() => {
        if (!vjsSrv.vjsPlayer.paused()) {
          vjsSrv.vjsPlayer.pause();
          this.adsManager.pause();
        }
      });
    }
    if (adEvent.type === google.ima.AdEvent.Type.COMPLETE || adEvent.type === google.ima.AdEvent.Type.SKIPPED) {
      // this.currentAd = null;
      this._playing = false;
    }
    if (adEvent.type === google.ima.AdEvent.Type.STARTED) {
      Analytics.send('ad_show');
      if (device.isIOS() && device.isSafari() && vjsSrv.vjsPlayer.isFullscreen()) {
        vjsSrv.vjsPlayer.exitFullscreen();
      }
      if (ad) {
        this._playing = ad.isLinear();
        if (ad.isLinear() && this.closeBannerTimeoutId) {
          clearTimeout(this.closeBannerTimeoutId);
          this.closeBannerTimeoutId = null;
        } else if (!ad.isLinear()) {
          const suggestedDuration = ad.getMinSuggestedDuration() || 10;
          let bannerDuration = suggestedDuration;
          if (vimmiPI.getActiveAsset().get('adex.overlay_duration_rpriority') === 'adex') {
            bannerDuration = vimmiPI.getActiveAsset().get('adex.overlay_duration') || bannerDuration;
            // if (vimmiPI.getActiveAsset().get('adex.overlay_duration')) {
            //   bannerDuration = vimmiPI.getActiveAsset().get('adex.overlay_duration')
            // if (vimmiPI.getActiveAsset().get('adex.overlay_gap_time_rpriority') === 'adex' && vimmiPI.getActiveAsset().get('adex.overlay_gap_time') && vimmiPI.getActiveAsset().get('adex.overlay_gap_time') <= vimmiPI.getActiveAsset().get('adex.overlay_duration')) {
            //   bannerDuration = vimmiPI.getActiveAsset().get('adex.overlay_gap_time') - 2;
            // } else {
            //   bannerDuration = vimmiPI.getActiveAsset().get('adex.overlay_duration');
            // }
            // }
          }
          if (bannerDuration) {
            this.closeBannerTimeoutId = setTimeout(() => {
              if (Config.get('eventsState.ended') && this.hasPostRoll) {
                $logger.p('ads/bannerTimeout').log(`skip close banner, because waiting postrolls!`, ad);
              } else {
                $logger.p('ads/bannerTimeout').log(`close banner:`, ad);
                this.adsManager.stop();
              }
              this.closeBannerTimeoutId = null;
              this.currentAd = null;
            }, (bannerDuration * 1000));
            $logger.p('ads/bannerTimeout').log(`init setTimeout to close banner: ${bannerDuration}s`, ad);
          }
        }
      }

      const cuePoints = vjsSrv.vjsPlayer.ima.getAdsManager().getCuePoints();
      this.hasPreRoll = cuePoints.indexOf(0) !== -1; // preroll has index 0
      this.hasPostRoll = cuePoints.indexOf(-1) !== -1;// postroll has index -1
      this.hasMidRoll = (cuePoints.length >= 2 && (!this.hasPreRoll || !this.hasPostRoll)) || (cuePoints.length >= 3 && (this.hasPreRoll && this.hasPostRoll));
      if (!this.hasPreRoll) {
        vjsSrv.vjsPlayer.trigger('nopreroll');
      } else {
        vjsSrv.vjsPlayer.ads.nopreroll_ = false;
      }
      if (!this.hasPostRoll) {
        vjsSrv.vjsPlayer.trigger('nopostroll');
      } else {
        vjsSrv.vjsPlayer.ads.nopostroll_ = false;
      }
      this.currentAd = adEvent.getAd();
    }
  }

  checkAdblock() {
    let tag = document.createElement('div');
    let isBlocked = false;

    tag.textContent = 'Test is adbl';
    tag.className = 'dfp-ad backdrop-dfp check_ad';
    tag.id = 'banner';
    document.getElementsByTagName('body')[0].appendChild(tag);
    let adElement = document.getElementById('banner') ? document.getElementById('banner') : '';

    if (adElement.offsetHeight === 0) {
      isBlocked = true;
    }
    adElement.parentNode.removeChild(adElement);

    return isBlocked;
  }

  async clear() {
    this.withAds = false;
    return new Promise((resolve) => {
      // if (this.isBuggedIos && !this.autoplayBrowserAllow) {
      //   this.isAdDisplayContainerInit = false;
      // }
      if (this.isAdInit || this._playing) {
        this._playing = false;
        vjsSrv.vjsPlayer.ima.controller.reset();
        vjsSrv.vjsPlayer.ima.controller.setSetting('adsResponse', null);
        vjsSrv.vjsPlayer.ima.controller.setSetting('adTagUrl', null);
        vjsSrv.vjsPlayer.ima.controller.setSetting('trackByWatchTime', false);
      }
      setTimeout(() => { //need for properly play pre-roll ads on next video
        resolve(true);
      });
    });

  }
}

const ads = new Ads();

export default ads;


